import { JobListsContext } from '@components/contexts/JobListsContext';
import { Modal } from '@components/common';
import { JobDetailHub } from '@components/templates/job/JobDetailHub';
import { useMemo, useState } from 'react';
import { useUrlChange } from '@utils/url/useUrlChange';
import { useTwoColumnLayout } from '@components/layout/Layouts/TwoColumnLayout/TwoColumnLayoutContext';
import { clsx } from 'clsx';


// Interface
// *******************************************************************
export interface ChatJobModalInterface {
  locale: Locale,
  jobsArray: {
    items: ApiSchema<'JobItem'>[] | undefined
  }[] | undefined,
  onJobApplied?: (jobSlug: string) => void,

}


// Job modal in homepage from job card
// *******************************************************************
export const ChatJobModal = (props: ChatJobModalInterface) => {
  // Destructure props
  const { locale, jobsArray, onJobApplied } = props;
  const twoColumnLayout = useTwoColumnLayout();

  const [,fakeSetCurrentPage] = useState<number>(1);

  const jobListsContext = useMemo(() => ({
    swrJobList: jobsArray,
    showLoadMore: false,
    size: jobsArray?.length,
    setSize: fakeSetCurrentPage as never,
    isLoading: false,
    onJobApplied,
  }), [jobsArray, onJobApplied]);


  const [selectedJobSlugQueryParam, setSelectedJobSlug] = useState<string | null>(null);

  // Function to check if the selectedJobSlug exists in the URL
  const checkSelectedJobSlug = (url: string) => {
    // If the URL is relative, combine it with the current origin to make it absolute
    const absoluteUrl = url.startsWith('http') ? url : `${window.location.origin}${url}`;

    // Create a new URL object
    const { searchParams } = new URL(absoluteUrl);

    // Return the value of the 'selectedJobSlug' parameter, or null if it's not found
    return searchParams.get('selectedJobSlug');
  };

  // Detect URL changes and check for selectedJobSlug
  useUrlChange((newUrl: string) => {
    const jobSlug = checkSelectedJobSlug(newUrl);
    setSelectedJobSlug(jobSlug); // Update the state with the slug
  });

  const [currentListUrl] = useState<string>(typeof window !== 'undefined' ? window.location.href : '');

  const closeJobModal = () => {
    // Use window.history.replaceState to update the URL without adding a new history entry
    window.history.replaceState(null, '', currentListUrl);
  };

  const modalPanelClasses = clsx(
    '!transform-none',
    twoColumnLayout
      ? (
        twoColumnLayout.isLeftOpen
          ? 'lg:ml-[17%] lg:!w-[83%]'
          : 'lg:ml-[64px] lg:!w-[calc(100%_-_64px)]'
      )
      : '',
  );


  return (
    <>
      {typeof selectedJobSlugQueryParam === 'string' && selectedJobSlugQueryParam && jobsArray && jobsArray?.length > 0 && (
        <JobListsContext.Provider value={jobListsContext}>
          <Modal
            isOpen
            onClose={closeJobModal}
            size="full"
            containerClasses="overflow-x-hidden"
            className={modalPanelClasses}
            body={(
              <JobDetailHub
                jobSlug={selectedJobSlugQueryParam}
                closeModal={closeJobModal}
                locale={locale}
              />
            )}
          />
        </JobListsContext.Provider>
      )}
    </>
  );
};
